import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import classnames from "classnames";
import { ReactBingmaps } from "react-bingmaps";

import * as api from "Api";
import _ from "i18n";
import styles from "./ManagePublicPortal.local.scss";

import {
  addNewBloc,
  setSelectedLayout,
  setCurrentNavPage,
  displayFlashMessage
} from "Actions";
import Switch from "Common/StateSwitch/Switch";
import DeleteConfirm from "Common/Confirm/DeleteConfirm";
import TimeInput from "./TimeInput";

const days = ["MON", "TUE", "WED", "TUR", "FRI", "SAT", "SUN"];

class ManagePublicPortal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      saving: false,
      isDeleteModalOpen: false,
      subdomain: "",
      pageId: null,
      portalDetails: {
        media: { activated: false },
        news: { activated: false },
        team: { activated: false },
        documents: { activated: false },
        contact: {
          activated: false,
          latitude: "50.8503396",
          longitude: "4.3517103",
          schedule: {
            MON: {
              MORNING: { FROM: "", TO: "" },
              AFTERNOON: { FROM: "", TO: "" }
            },
            TUE: {
              MORNING: { FROM: "", TO: "" },
              AFTERNOON: { FROM: "", TO: "" }
            },
            WED: {
              MORNING: { FROM: "", TO: "" },
              AFTERNOON: { FROM: "", TO: "" }
            },
            TUR: {
              MORNING: { FROM: "", TO: "" },
              AFTERNOON: { FROM: "", TO: "" }
            },
            FRI: {
              MORNING: { FROM: "", TO: "" },
              AFTERNOON: { FROM: "", TO: "" }
            },
            SAT: {
              MORNING: { FROM: "", TO: "" },
              AFTERNOON: { FROM: "", TO: "" }
            },
            SUN: {
              MORNING: { FROM: "", TO: "" },
              AFTERNOON: { FROM: "", TO: "" }
            }
          }
        }
      }
    };
    this.resetData = this.resetData.bind(this);
  }

  componentDidMount() {
    const { auth } = this.props;
    const { token, navCommunity } = auth;

    this.props.setCurrentNavPage("SETTING_PUBLIC_PAGE");
    api
      .getPublicPage({
        token,
        communityId: navCommunity.id
      })
      .then(resp => {
        if (resp.data.data && resp.data.data.length > 0) {
          let subdomain = resp.data.data[0].subdomain || "";
          if (
            navCommunity &&
            subdomain ===
              `portal.tamtam.pro/public/${navCommunity.url}/${navCommunity.id}`
          ) {
            subdomain = "";
          }
          this.setState({
            pageId: resp.data.data[0].id,
            subdomain: subdomain,
            portalDetails: JSON.parse(resp.data.data[0].details)
          });
        }
      });
  }

  handlePortalBlocChange = key => {
    const value = !this.state.portalDetails[key].activated;
    this.setState({
      portalDetails: {
        ...this.state.portalDetails,
        [key]: {
          ...this.state.portalDetails[key],
          activated: value
        }
      }
    });
  };

  handlePortalDomainChange = e => {
    this.setState({ subdomain: e.target.value });
  };

  handleGeoChange = (e, field) => {
    this.setState({
      portalDetails: {
        ...this.state.portalDetails,
        contact: {
          ...this.state.portalDetails.contact,
          [field]: e.target.value
        }
      }
    });
  };

  addPushPinOnClick = location => {
    this.setState({
      portalDetails: {
        ...this.state.portalDetails,
        contact: {
          ...this.state.portalDetails.contact,
          latitude: location.latitude,
          longitude: location.longitude
        }
      }
    });
  };

  handleChangeSchedule = (value, day, time, start) => {
    let data =
      value === "NO_WORK"
        ? this.state.portalDetails.contact.schedule[day][time].FROM ===
          "NO_WORK"
          ? {
              FROM: "",
              TO: ""
            }
          : {
              FROM: value,
              TO: value
            }
        : {
            ...this.state.portalDetails.contact.schedule[day][time],
            [start]: value
          };
    this.setState({
      portalDetails: {
        ...this.state.portalDetails,
        contact: {
          ...this.state.portalDetails.contact,
          schedule: {
            ...this.state.portalDetails.contact.schedule,
            [day]: {
              ...this.state.portalDetails.contact.schedule[day],
              [time]: data
            }
          }
        }
      }
    });
  };

  handleApplySchedule = () => {
    const mondayData = this.state.portalDetails.contact.schedule["MON"];
    let data = { MON: mondayData };
    days.forEach(day => {
      if (day !== "MON") {
        data[day] = mondayData;
      }
    });
    this.setState({
      portalDetails: {
        ...this.state.portalDetails,
        contact: {
          ...this.state.portalDetails.contact,
          schedule: data
        }
      }
    });
  };

  save = () => {
    const { auth, lng, displayFlashMessage } = this.props;
    const { token, user, navCommunity } = auth;
    const { pageId, subdomain, portalDetails } = this.state;

    let subdomainValue = subdomain;
    if (!subdomainValue && navCommunity) {
      subdomainValue = `portal.tamtam.pro/public/${navCommunity.url}/${
        navCommunity.id
      }`;
    } else {
      // remove https
      subdomainValue = subdomainValue.replace(/(^\w+:|^)\/\//, "");
    }

    const data = {
      title: "Public portal",
      subtitle: "",
      language: lng,
      resource: "PUBLIC_PORTAL",
      communityId: navCommunity.id,
      userId: user.id,
      subdomain: subdomainValue,
      details: portalDetails,
      token
    };
    if (pageId) {
      data.id = pageId;
    }
    this.setState({ saving: true });

    api
      .savePage(data)
      .then(() => {
        this.setState({ saving: false });
        displayFlashMessage("SUCCESS", _("Settings changed successfully"));
      })
      .catch(() => {
        this.setState({ saving: false });
        displayFlashMessage("ERROR", "Could not save page");
      });
  };

  closeModalDelete() {
    this.setState({ isDeleteModalOpen: false });
  }

  openModalDelete() {
    this.setState({
      isDeleteModalOpen: true
    });
  }

  onConfirmDelete() {
    const { pageId } = this.state;
    const { auth } = this.props;
    const { token } = auth;

    this.setState({ isDeleteModalOpen: false });
    api
      .deletePage({
        token,
        pageId
      })
      .then(() => {
        this.resetData();
        displayFlashMessage("SUCCESS", _("Page deleted successfully"));
      })
      .catch(() => {
        displayFlashMessage("ERROR", "Could not delete the page");
      });
  }

  resetData() {
    this.setState({
      subdomain: "",
      pageId: null,
      portalDetails: {
        media: { activated: false },
        news: { activated: false },
        team: { activated: false },
        documents: { activated: false },
        contact: {
          activated: false,
          latitude: "50.8503396",
          longitude: "4.3517103",
          schedule: {
            MON: {
              MORNING: { FROM: "", TO: "" },
              AFTERNOON: { FROM: "", TO: "" }
            },
            TUE: {
              MORNING: { FROM: "", TO: "" },
              AFTERNOON: { FROM: "", TO: "" }
            },
            WED: {
              MORNING: { FROM: "", TO: "" },
              AFTERNOON: { FROM: "", TO: "" }
            },
            TUR: {
              MORNING: { FROM: "", TO: "" },
              AFTERNOON: { FROM: "", TO: "" }
            },
            FRI: {
              MORNING: { FROM: "", TO: "" },
              AFTERNOON: { FROM: "", TO: "" }
            },
            SAT: {
              MORNING: { FROM: "", TO: "" },
              AFTERNOON: { FROM: "", TO: "" }
            },
            SUN: {
              MORNING: { FROM: "", TO: "" },
              AFTERNOON: { FROM: "", TO: "" }
            }
          }
        }
      }
    });
  }

  render() {
    const { auth } = this.props;
    const { navCommunity } = auth;
    const { pageId, subdomain, portalDetails, saving } = this.state;

    return (
      <div className={styles.layout}>
        <div className={styles.header}>
          <NavLink to="/" className={styles.back}>
            <span className={styles.arrow} />
            {_("Home")}
          </NavLink>
          <h1>{_("Manage Public Portal")}</h1>
        </div>

        <div className={styles.body}>
          <div className={styles.head}>
            <div className={styles.titles}>
              <h2>{_("Configure public portal")}</h2>
              <p>{_("Ajouter et configurer le portail publique")}</p>
            </div>
            <div className={styles.saveBtn}>
              {pageId && (
                <button
                  className={styles.trash}
                  onClick={this.openModalDelete.bind(this)}
                >
                  {_("Delete")}
                </button>
              )}
              <button className={styles.save} onClick={this.save.bind(this)}>
                {saving ? (
                  <i className={classnames(styles.saving, "icon-options")} />
                ) : (
                  _("Save")
                )}
              </button>
            </div>
          </div>

          <div className="grid-x grid-margin-x grid-margin-y">
            <div className="cell small-12 medium-6">
              <div className={styles.portalBloc}>
                <div className={styles.portalBloc_domain}>
                  <label>{_("Default domain")}</label>
                  <input
                    type="text"
                    className={styles.formInput}
                    value={
                      navCommunity
                        ? `portal.tamtam.pro/public/${navCommunity.url}/${
                            navCommunity.id
                          }`
                        : ""
                    }
                    disabled
                  />
                </div>
                <div className={styles.portalBloc_form}>
                  <label>{_("Subdomain")}</label>
                  <input
                    type="text"
                    className={styles.formInput}
                    value={subdomain}
                    onChange={this.handlePortalDomainChange}
                  />
                </div>
              </div>
              <div className={styles.portalBloc}>
                <div className={styles.portalBloc_top}>
                  <label>{_("Media")}</label>
                  <Switch
                    isChecked={portalDetails.media.activated}
                    onChange={() => this.handlePortalBlocChange("media")}
                  />
                </div>
                <div className={styles.portalBloc_model}>
                  <svg viewBox="0 0 98 18" fill="none">
                    <rect width="76" height="16" rx="1" fill="#D8DDE2" />
                    <rect x="78" width="20" height="16" rx="1" fill="#EBEEF0" />
                  </svg>
                </div>
              </div>
              <div className={styles.portalBloc}>
                <div className={styles.portalBloc_top}>
                  <label>{_("News")}</label>
                  <Switch
                    isChecked={portalDetails.news.activated}
                    onChange={() => this.handlePortalBlocChange("news")}
                  />
                </div>
                <div className={styles.portalBloc_newsmodel}>
                  <svg viewBox="0 0 98 40" fill="none">
                    <rect width="56" height="8" rx="1" fill="#D8DDE2" />
                    <rect x="58" width="40" height="38" rx="1" fill="#EBEEF0" />
                    <rect y="10" width="56" height="8" rx="1" fill="#D8DDE2" />
                    <rect y="20" width="56" height="8" rx="1" fill="#D8DDE2" />
                    <rect y="30" width="56" height="8" rx="1" fill="#D8DDE2" />
                  </svg>
                </div>
              </div>
              <div className={styles.portalBloc}>
                <div className={styles.portalBloc_top}>
                  <label>{_("Team")}</label>
                  <Switch
                    name="team"
                    isChecked={portalDetails.team.activated}
                    onChange={() => this.handlePortalBlocChange("team")}
                  />
                </div>
                <div className={styles.portalBloc_model}>
                  <svg viewBox="0 0 128 20" fill="none">
                    <rect width="40" height="20" rx="1" fill="#EBEEF0" />
                    <rect x="44" width="40" height="20" rx="1" fill="#EBEEF0" />
                    <rect x="88" width="40" height="20" rx="1" fill="#EBEEF0" />
                  </svg>
                </div>
              </div>
              <div className={styles.portalBloc}>
                <div className={styles.portalBloc_top}>
                  <label>{_("Documents")}</label>
                  <Switch
                    name="documents"
                    isChecked={portalDetails.documents.activated}
                    onChange={() => this.handlePortalBlocChange("documents")}
                  />
                </div>
                <div className={styles.portalBloc_model}>
                  <svg viewBox="0 0 98 16" fill="none">
                    <rect width="98" height="16" rx="1" fill="#EBEEF0" />
                  </svg>
                </div>
              </div>
            </div>

            <div className="cell small-12 medium-6">
              <div className={styles.portalBloc}>
                <div className={styles.portalBloc_top}>
                  <label>{_("Contact")}</label>
                  <Switch
                    name="contact"
                    isChecked={portalDetails.contact.activated}
                    onChange={() => this.handlePortalBlocChange("contact")}
                  />
                </div>
                <div className={styles.portalBloc_model}>
                  <svg viewBox="0 0 128 20" fill="none">
                    <rect width="60" height="20" rx="1" fill="#D8DDE2" />
                    <rect x="64" width="30" height="20" rx="1" fill="#EBEEF0" />
                    <rect x="98" width="30" height="20" rx="1" fill="#EBEEF0" />
                  </svg>
                </div>
              </div>
              {portalDetails.contact.activated && (
                <div>
                  <div className={styles.geobox}>
                    <div className={styles.geobox_left}>
                      <label>{_("Latitude")}</label>
                      <input
                        type="text"
                        className={styles.formInput}
                        value={portalDetails.contact.latitude}
                        onChange={e => this.handleGeoChange(e, "latitude")}
                      />
                    </div>
                    <div className={styles.geobox_right}>
                      <label>{_("Longitude")}</label>
                      <input
                        type="text"
                        className={styles.formInput}
                        value={portalDetails.contact.longitude}
                        onChange={e => this.handleGeoChange(e, "longitude")}
                      />
                    </div>
                  </div>

                  <div className={styles.mapbox}>
                    <ReactBingmaps
                      bingmapKey="AlfqRT9EH4KtKEzZQp4yhxAIWxiujabG1jpSuUJaQ_GWxN9ONI_MQvd_e2kJpK5H"
                      zoom={14}
                      mapTypeId={"aerial"}
                      center={[
                        parseFloat(portalDetails.contact.latitude),
                        parseFloat(portalDetails.contact.longitude)
                      ]}
                      navigationBarMode={"compact"}
                      getLocation={{
                        addHandler: "click",
                        callback: this.addPushPinOnClick
                      }}
                      pushPins={[
                        {
                          location: [
                            parseFloat(portalDetails.contact.latitude),
                            parseFloat(portalDetails.contact.longitude)
                          ],
                          option: {
                            color: "#18A0FB",
                            icon:
                              "https://unpkg.com/leaflet@1.3.3/dist/images/marker-icon.png"
                          }
                        }
                      ]}
                    />
                  </div>

                  <div className={styles.schedule}>
                    <div className={styles.schedule_row}>
                      <div
                        className={`${styles.schedule_header} ${
                          styles.schedule_day
                        }`}
                      >
                        {_("Day")}
                      </div>
                      <div
                        className={`${styles.schedule_header} ${
                          styles.schedule_hours
                        }`}
                      >
                        {_("Morning")}
                      </div>
                      <div
                        className={`${styles.schedule_header} ${
                          styles.schedule_hours
                        }`}
                      >
                        {_("Afternoon")}
                      </div>
                      <div className={`${styles.schedule_action}`}> </div>
                    </div>
                    {days.map(day => {
                      return (
                        <div className={styles.schedule_row} key={`day${day}`}>
                          <div className={`${styles.schedule_day}`}>{day}</div>
                          <div className={`${styles.schedule_hours}`}>
                            <div className={styles.schedule_input}>
                              <TimeInput
                                value={
                                  portalDetails.contact.schedule[day].MORNING
                                    .FROM
                                }
                                onChange={e =>
                                  this.handleChangeSchedule(
                                    e.target.value,
                                    day,
                                    "MORNING",
                                    "FROM"
                                  )
                                }
                              />
                              <span>{_("to")}</span>
                              <TimeInput
                                value={
                                  portalDetails.contact.schedule[day].MORNING.TO
                                }
                                onChange={e =>
                                  this.handleChangeSchedule(
                                    e.target.value,
                                    day,
                                    "MORNING",
                                    "TO"
                                  )
                                }
                              />
                            </div>
                            <div className={styles.schedule_nowork}>
                              <Switch
                                isChecked={
                                  portalDetails.contact.schedule[day].MORNING
                                    .FROM === "NO_WORK"
                                }
                                onChange={() =>
                                  this.handleChangeSchedule(
                                    "NO_WORK",
                                    day,
                                    "MORNING",
                                    "FROM"
                                  )
                                }
                              />
                              <span>{_("No work")}</span>
                            </div>
                          </div>
                          <div className={`${styles.schedule_hours}`}>
                            <div className={styles.schedule_input}>
                              <TimeInput
                                value={
                                  portalDetails.contact.schedule[day].AFTERNOON
                                    .FROM
                                }
                                onChange={e =>
                                  this.handleChangeSchedule(
                                    e.target.value,
                                    day,
                                    "AFTERNOON",
                                    "FROM"
                                  )
                                }
                              />
                              <span>{_("to")}</span>
                              <TimeInput
                                value={
                                  portalDetails.contact.schedule[day].AFTERNOON
                                    .TO
                                }
                                onChange={e =>
                                  this.handleChangeSchedule(
                                    e.target.value,
                                    day,
                                    "AFTERNOON",
                                    "TO"
                                  )
                                }
                              />
                            </div>
                            <div className={styles.schedule_nowork}>
                              <Switch
                                isChecked={
                                  portalDetails.contact.schedule[day].AFTERNOON
                                    .FROM === "NO_WORK"
                                }
                                onChange={() =>
                                  this.handleChangeSchedule(
                                    "NO_WORK",
                                    day,
                                    "AFTERNOON",
                                    "FROM"
                                  )
                                }
                              />
                              <span>{_("No work")}</span>
                            </div>
                          </div>
                          <div className={`${styles.schedule_action}`}>
                            {day === "MON" && (
                              <span
                                className={styles.schedule_btn}
                                onClick={this.handleApplySchedule}
                              >
                                {_("Apply for all days")}
                              </span>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <DeleteConfirm
          isOpen={this.state.isDeleteModalOpen}
          onCancel={() => this.closeModalDelete()}
          onConfirm={() => this.onConfirmDelete()}
          text={_("Are you sure you want to delete the page ?")}
        />
      </div>
    );
  }
}
const mapStateToProps = state => ({
  lng: state.params.lng,
  auth: state.auth
});
const mapDispatchToProps = dispatch => ({
  addNewBloc: () => dispatch(addNewBloc()),
  displayFlashMessage: (status, msg) =>
    dispatch(displayFlashMessage(status, msg)),
  setSelectedLayout: index => dispatch(setSelectedLayout(index)),
  setCurrentNavPage: page => dispatch(setCurrentNavPage(page))
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManagePublicPortal);



// WEBPACK FOOTER //
// ./src/components/Settings/ManagePublicPortal/index.js